import {keyBy} from "lodash-es";
import type {TStore} from "modules/types/store";
import {createSelector} from "reselect";

export const getSquads = (store: TStore) => store.squads;

export const getSquadsById = createSelector([getSquads], (squads) => keyBy(squads, "id"));

export const getSquadsByIds = createSelector(
	[getSquadsById],
	(squads) => (squadIds: (number | undefined)[] | string[]) => {
		return squadIds.map((id) => (id ? squads[id] : null));
	}
);
